// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otpVerificationContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.verificationText {
  font-family: "Poppins", sans-serif;
  font-weight: 600px;
  font-size: 24px;
  line-height: 32px;
}
.enterText {
  font-family: "Poppins", sans-serif;
  font-weight: 400px;
  font-size: 16px;
  line-height: 24px;
  margin-top: 12px;
}

.enterOtpText {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}
.otpInputContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}
.otpInputTrue {
  all: unset;
  border: 1px solid #6a6a6a;
  height: 8vh;
  width: 4vw;
  border-radius: 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
}
.otpInputFalse{
  all: unset;
  border: 1px solid #FFA7A7;
  height: 8vh;
  width: 4vw;
  border-radius: 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
}
.resendCodeContainer {
  margin-top: 20px;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
}
.resendBtn-disabled {
  all: unset;
}
.resendBtn-active {
  all: unset;
  color: #48d1cc;
  cursor: pointer;
}

/* Mobile Responsive Styles - Only for small devices */
@media (max-width: 768px) {
  .otpVerificationContainer {
    padding: 0 20px;
    width: 100%;
    box-sizing: border-box;
  }
  
  .otpInputContainer {
    gap: 8px;
    width: 100%;
    max-width: 100%;
    justify-content: space-between;
    padding: 0 10px;
  }
  
  .otpInputTrue,
  .otpInputFalse {
    height: 50px;
    width: 100%;
    max-width: 50px;
    min-width: 40px;
    font-size: 20px;
    border-radius: 10px;
    flex: 1 1;
  }
}

@media (max-width: 480px) {
  .otpVerificationContainer {
    padding: 0 16px;
  }
  
  .otpInputContainer {
    gap: 6px;
    padding: 0 5px;
  }
  
  .otpInputTrue,
  .otpInputFalse {
    height: 45px;
    width: 100%;
    max-width: 45px;
    min-width: 35px;
    font-size: 18px;
    border-radius: 8px;
  }
}

@media (max-width: 360px) {
  .otpVerificationContainer {
    padding: 0 12px;
  }
  
  .otpInputContainer {
    gap: 4px;
    padding: 0 2px;
  }
  
  .otpInputTrue,
  .otpInputFalse {
    height: 40px;
    width: 100%;
    max-width: 40px;
    min-width: 30px;
    font-size: 16px;
    border-radius: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/SignUpFlow/EmailOtpVerification/EmailOtpVerification.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE;IACE,eAAe;IACf,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,SAAO;EACT;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,cAAc;EAChB;;EAEA;;IAEE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,cAAc;EAChB;;EAEA;;IAEE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n.otpVerificationContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.verificationText {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600px;\n  font-size: 24px;\n  line-height: 32px;\n}\n.enterText {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400px;\n  font-size: 16px;\n  line-height: 24px;\n  margin-top: 12px;\n}\n\n.enterOtpText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n}\n.otpInputContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n.otpInputTrue {\n  all: unset;\n  border: 1px solid #6a6a6a;\n  height: 8vh;\n  width: 4vw;\n  border-radius: 10px;\n  box-sizing: border-box;\n  text-align: center;\n  font-size: 18px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n}\n.otpInputFalse{\n  all: unset;\n  border: 1px solid #FFA7A7;\n  height: 8vh;\n  width: 4vw;\n  border-radius: 10px;\n  box-sizing: border-box;\n  text-align: center;\n  font-size: 18px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n}\n.resendCodeContainer {\n  margin-top: 20px;\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n}\n.resendBtn-disabled {\n  all: unset;\n}\n.resendBtn-active {\n  all: unset;\n  color: #48d1cc;\n  cursor: pointer;\n}\n\n/* Mobile Responsive Styles - Only for small devices */\n@media (max-width: 768px) {\n  .otpVerificationContainer {\n    padding: 0 20px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n  \n  .otpInputContainer {\n    gap: 8px;\n    width: 100%;\n    max-width: 100%;\n    justify-content: space-between;\n    padding: 0 10px;\n  }\n  \n  .otpInputTrue,\n  .otpInputFalse {\n    height: 50px;\n    width: 100%;\n    max-width: 50px;\n    min-width: 40px;\n    font-size: 20px;\n    border-radius: 10px;\n    flex: 1;\n  }\n}\n\n@media (max-width: 480px) {\n  .otpVerificationContainer {\n    padding: 0 16px;\n  }\n  \n  .otpInputContainer {\n    gap: 6px;\n    padding: 0 5px;\n  }\n  \n  .otpInputTrue,\n  .otpInputFalse {\n    height: 45px;\n    width: 100%;\n    max-width: 45px;\n    min-width: 35px;\n    font-size: 18px;\n    border-radius: 8px;\n  }\n}\n\n@media (max-width: 360px) {\n  .otpVerificationContainer {\n    padding: 0 12px;\n  }\n  \n  .otpInputContainer {\n    gap: 4px;\n    padding: 0 2px;\n  }\n  \n  .otpInputTrue,\n  .otpInputFalse {\n    height: 40px;\n    width: 100%;\n    max-width: 40px;\n    min-width: 30px;\n    font-size: 16px;\n    border-radius: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
